module.exports = __webpack_public_path__ + "img/calendar-mobile.e09e6534.svg";